import { useContext, useState } from 'react';
import { Message } from 'app/components/AiBots/types';
import { GetConfigFromAI } from 'services/apiServices';
import { Errors, TGetConfigFromAIParams, TGetConfigFromAIResult } from 'types/ApiServicesTypes';
import { useMutation, useQuery } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';

export const useAiChat = () => {
    const { showAlert } = useContext(ToastContext);

    const mutation = useMutation<TGetConfigFromAIResult, Errors, TGetConfigFromAIParams>(
    'GetConfigFromAI',
    values =>
        GetConfigFromAI(values)
        .then(res => {
            return res;
        })
        .catch(err => {
            // showAlert!(err.message as string);
            return err;
        }),
    );

    if (mutation.isError && mutation.error) {
        showAlert!(mutation.error.message);
    }

    return mutation;
    
}; 